import { GeneratePanelV2 } from "@hg/recall-frame"
import classNames from "classnames"
import React, { FC } from "react"

import { sfxPlay } from "@/assets/audios/sfx"
import { GlobalStage, useGlobalStore } from "@/store/global"
// import { GlobalView, useSetGlobalView } from "@/store/view"
// import { i18n } from "@/i18n"
import { GlobalView, useSetGlobalView } from "@/store/view"
// import LineButton from "@/Topics/Recall/components/Buttons/LineButton"
import styles from "./index.module.scss"
import { MenuBtn } from "./MenuBtn"
import { menus } from "./menu"
import { Share } from "./Share"
// import { menus } from "./menu"
// import { Share } from "./Share"
// import { StagePointer, useSetStagePointer } from "@/context/stage"
// import { showRuleModal } from "../Poster"

export const Panel: FC = () => {
    return (
        <GeneratePanelV2
            backgroundCls={styles.background}
            panelCls={styles.panel}
            menuCls={styles.menu}
            contentCls={styles.content}
            renderMenuBtn={({ key, mid, onClick }) => (
                <MenuBtn key={key} {...{ mid, onClick }} />
            )}
            menus={menus}
            defaultMenu="task"
            // 分享任务点击后的弹窗
            renderShare={({ open, setOpen, onSubmit }) => (
                <Share {...{ open, setOpen, onSubmit }} />
            )}
            renderExtra={() => <Extra />}
        />
    )
}

const Extra: FC = () => {
    return (
        <ReturnHome />
    )
}

const ReturnHome: FC = () => {
    const { setGlobalStage } = useGlobalStore()
    const set = useSetGlobalView()

    const doJump = () => {
        setGlobalStage(GlobalStage.LOADING)
        set(GlobalView.MAIN)
        removeParam()
        sfxPlay("click")
    }

    const removeParam = () => {
        const url = new URL(window.location.href)
        url.searchParams.delete("page") // 删除 `page` 参数
        window.history.replaceState({}, document.title, url.toString()) // 更新地址栏
    }

    return <div className={styles.returnHome} onClick={doJump} />
}
